import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@hooks"
import { useTranslation } from "react-i18next";
import { Category } from "@types";

export const useGetCategories = () => {
    const axios = useAxios();
    const {t} = useTranslation();

    const fetchCategories = async () => {
        try {
            const response = await axios.get<Category[]>("/api/categories");
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getCategories"))
        }
    }

    return useQuery({queryKey: ["categories"], queryFn: fetchCategories, staleTime: Infinity});
}   